import { useMutation } from '@tanstack/react-query';

import { uploadDocumentsInDias } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

export default function useUploadDocumentsDias() {
  return useMutation({
    mutationFn: ({
      crmPartyId,
      documents,
    }: {
      crmPartyId: string;
      documents: Array<{
        filename: string;
        link: string;
        description?: string;
      }>;
    }) =>
      uploadDocumentsInDias(
        {
          params: {
            path: { dias_id: crmPartyId },
            query: {},
          },
          body: {
            documents,
          },
        },
        wgApi,
      ),
  });
}
